/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateBLConcurrencyLock = /* GraphQL */ `subscription OnCreateBLConcurrencyLock(
  $filter: ModelSubscriptionBLConcurrencyLockFilterInput
) {
  onCreateBLConcurrencyLock(filter: $filter) {
    community
    lockToken
    createdAt
    expirationUnixTime
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBLConcurrencyLockSubscriptionVariables,
  APITypes.OnCreateBLConcurrencyLockSubscription
>;
export const onUpdateBLConcurrencyLock = /* GraphQL */ `subscription OnUpdateBLConcurrencyLock(
  $filter: ModelSubscriptionBLConcurrencyLockFilterInput
) {
  onUpdateBLConcurrencyLock(filter: $filter) {
    community
    lockToken
    createdAt
    expirationUnixTime
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBLConcurrencyLockSubscriptionVariables,
  APITypes.OnUpdateBLConcurrencyLockSubscription
>;
export const onDeleteBLConcurrencyLock = /* GraphQL */ `subscription OnDeleteBLConcurrencyLock(
  $filter: ModelSubscriptionBLConcurrencyLockFilterInput
) {
  onDeleteBLConcurrencyLock(filter: $filter) {
    community
    lockToken
    createdAt
    expirationUnixTime
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBLConcurrencyLockSubscriptionVariables,
  APITypes.OnDeleteBLConcurrencyLockSubscription
>;
export const onCreateBoughtList = /* GraphQL */ `subscription OnCreateBoughtList(
  $filter: ModelSubscriptionBoughtListFilterInput
) {
  onCreateBoughtList(filter: $filter) {
    id
    saluation
    firstName
    lastName
    gender
    age
    address
    city
    state
    zipcode
    county
    householdIncome
    householdIncomeBottom
    householdIncomeTop
    homeValue
    homeValueBottom
    homeValueTop
    boatingSailing
    tennis
    golf
    boatOwner
    upscaleLiving
    suppress
    doNotMail
    dropDate
    zip5
    batchCode
    listDate
    listName
    listNameId
    qseq
    expirationDate
    lastUpdated
    site1
    siteDistance1
    epm3Decile1
    epm3Score1
    epm3Tier1
    site2
    siteDistance2
    epm3Decile2
    epm3Score2
    epm3Tier2
    blSelect
    hlMatch
    randomNumber
    randomFlag
    netNewFlag
    staticControlFlag
    hlGrpRowList
    hlODateList
    optOut
    optOutDateTime
    optOutUpdatedBy
    createdAt
    updatedAt
    expirationUnixTime
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBoughtListSubscriptionVariables,
  APITypes.OnCreateBoughtListSubscription
>;
export const onUpdateBoughtList = /* GraphQL */ `subscription OnUpdateBoughtList(
  $filter: ModelSubscriptionBoughtListFilterInput
) {
  onUpdateBoughtList(filter: $filter) {
    id
    saluation
    firstName
    lastName
    gender
    age
    address
    city
    state
    zipcode
    county
    householdIncome
    householdIncomeBottom
    householdIncomeTop
    homeValue
    homeValueBottom
    homeValueTop
    boatingSailing
    tennis
    golf
    boatOwner
    upscaleLiving
    suppress
    doNotMail
    dropDate
    zip5
    batchCode
    listDate
    listName
    listNameId
    qseq
    expirationDate
    lastUpdated
    site1
    siteDistance1
    epm3Decile1
    epm3Score1
    epm3Tier1
    site2
    siteDistance2
    epm3Decile2
    epm3Score2
    epm3Tier2
    blSelect
    hlMatch
    randomNumber
    randomFlag
    netNewFlag
    staticControlFlag
    hlGrpRowList
    hlODateList
    optOut
    optOutDateTime
    optOutUpdatedBy
    createdAt
    updatedAt
    expirationUnixTime
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBoughtListSubscriptionVariables,
  APITypes.OnUpdateBoughtListSubscription
>;
export const onDeleteBoughtList = /* GraphQL */ `subscription OnDeleteBoughtList(
  $filter: ModelSubscriptionBoughtListFilterInput
) {
  onDeleteBoughtList(filter: $filter) {
    id
    saluation
    firstName
    lastName
    gender
    age
    address
    city
    state
    zipcode
    county
    householdIncome
    householdIncomeBottom
    householdIncomeTop
    homeValue
    homeValueBottom
    homeValueTop
    boatingSailing
    tennis
    golf
    boatOwner
    upscaleLiving
    suppress
    doNotMail
    dropDate
    zip5
    batchCode
    listDate
    listName
    listNameId
    qseq
    expirationDate
    lastUpdated
    site1
    siteDistance1
    epm3Decile1
    epm3Score1
    epm3Tier1
    site2
    siteDistance2
    epm3Decile2
    epm3Score2
    epm3Tier2
    blSelect
    hlMatch
    randomNumber
    randomFlag
    netNewFlag
    staticControlFlag
    hlGrpRowList
    hlODateList
    optOut
    optOutDateTime
    optOutUpdatedBy
    createdAt
    updatedAt
    expirationUnixTime
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBoughtListSubscriptionVariables,
  APITypes.OnDeleteBoughtListSubscription
>;
export const onCreateUserFilter = /* GraphQL */ `subscription OnCreateUserFilter(
  $filter: ModelSubscriptionUserFilterFilterInput
  $owner: String
) {
  onCreateUserFilter(filter: $filter, owner: $owner) {
    id
    listType
    name
    filterDefinitions
    filterSelections
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserFilterSubscriptionVariables,
  APITypes.OnCreateUserFilterSubscription
>;
export const onUpdateUserFilter = /* GraphQL */ `subscription OnUpdateUserFilter(
  $filter: ModelSubscriptionUserFilterFilterInput
  $owner: String
) {
  onUpdateUserFilter(filter: $filter, owner: $owner) {
    id
    listType
    name
    filterDefinitions
    filterSelections
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserFilterSubscriptionVariables,
  APITypes.OnUpdateUserFilterSubscription
>;
export const onDeleteUserFilter = /* GraphQL */ `subscription OnDeleteUserFilter(
  $filter: ModelSubscriptionUserFilterFilterInput
  $owner: String
) {
  onDeleteUserFilter(filter: $filter, owner: $owner) {
    id
    listType
    name
    filterDefinitions
    filterSelections
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserFilterSubscriptionVariables,
  APITypes.OnDeleteUserFilterSubscription
>;
export const onCreateExportJob = /* GraphQL */ `subscription OnCreateExportJob(
  $filter: ModelSubscriptionExportJobFilterInput
  $owner: String
) {
  onCreateExportJob(filter: $filter, owner: $owner) {
    id
    exportName
    listType
    reportId
    status
    statusMessage
    filterInput
    filterFields
    outputFormat
    s3Key
    totalRecords
    fileSize
    startedAt
    expiresAt
    createdAt
    updatedAt
    owner
    authorizedReaders
    debugInfo
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateExportJobSubscriptionVariables,
  APITypes.OnCreateExportJobSubscription
>;
export const onUpdateExportJob = /* GraphQL */ `subscription OnUpdateExportJob(
  $filter: ModelSubscriptionExportJobFilterInput
  $owner: String
) {
  onUpdateExportJob(filter: $filter, owner: $owner) {
    id
    exportName
    listType
    reportId
    status
    statusMessage
    filterInput
    filterFields
    outputFormat
    s3Key
    totalRecords
    fileSize
    startedAt
    expiresAt
    createdAt
    updatedAt
    owner
    authorizedReaders
    debugInfo
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateExportJobSubscriptionVariables,
  APITypes.OnUpdateExportJobSubscription
>;
export const onDeleteExportJob = /* GraphQL */ `subscription OnDeleteExportJob(
  $filter: ModelSubscriptionExportJobFilterInput
  $owner: String
) {
  onDeleteExportJob(filter: $filter, owner: $owner) {
    id
    exportName
    listType
    reportId
    status
    statusMessage
    filterInput
    filterFields
    outputFormat
    s3Key
    totalRecords
    fileSize
    startedAt
    expiresAt
    createdAt
    updatedAt
    owner
    authorizedReaders
    debugInfo
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteExportJobSubscriptionVariables,
  APITypes.OnDeleteExportJobSubscription
>;
export const onCreateReportRunSchedule = /* GraphQL */ `subscription OnCreateReportRunSchedule(
  $filter: ModelSubscriptionReportRunScheduleFilterInput
) {
  onCreateReportRunSchedule(filter: $filter) {
    id
    reportId
    scheduleExpression
    enabled
    subscribers
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateReportRunScheduleSubscriptionVariables,
  APITypes.OnCreateReportRunScheduleSubscription
>;
export const onUpdateReportRunSchedule = /* GraphQL */ `subscription OnUpdateReportRunSchedule(
  $filter: ModelSubscriptionReportRunScheduleFilterInput
) {
  onUpdateReportRunSchedule(filter: $filter) {
    id
    reportId
    scheduleExpression
    enabled
    subscribers
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateReportRunScheduleSubscriptionVariables,
  APITypes.OnUpdateReportRunScheduleSubscription
>;
export const onDeleteReportRunSchedule = /* GraphQL */ `subscription OnDeleteReportRunSchedule(
  $filter: ModelSubscriptionReportRunScheduleFilterInput
) {
  onDeleteReportRunSchedule(filter: $filter) {
    id
    reportId
    scheduleExpression
    enabled
    subscribers
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteReportRunScheduleSubscriptionVariables,
  APITypes.OnDeleteReportRunScheduleSubscription
>;
export const onCreateHouselistNew = /* GraphQL */ `subscription OnCreateHouselistNew(
  $filter: ModelSubscriptionHouselistNewFilterInput
) {
  onCreateHouselistNew(filter: $filter) {
    id
    accountID
    listName
    listNameId
    control
    homeValue
    homeValueBottom
    homeValueTop
    hohIncome
    hohIncomeBottom
    hohIncomeTop
    hohNetWorth
    hohNetWorthBottom
    hohNetWorthTop
    groupName
    birthDate
    deceasedDate
    distanceToSite
    doNotCall
    email
    emailBounceDate
    epm2Grade
    epm2Score
    epm2Tier
    firstName
    gender
    hasOptedOutOfEmail
    hohAge
    homePhone
    contactId
    ilContactStatus
    labelSalutation
    lastName
    letterSalutation
    neighborhood
    city
    zip5
    zipcode
    state
    address
    maritalStatus
    mlActive
    cellPhone
    primaryContact
    primarySite
    latitude
    longitude
    qasValidationStatus
    contactType
    returnedMail
    ccContactStatus
    opportunitySite
    opportunityId
    loc
    ltsGrade
    ltsScore
    primaryMotivation
    communityName
    rating
    segmentation
    settledDate
    salesStage
    priorityDate
    reservationDate
    businessType
    salesOptionDate
    apartmentName
    optOut
    optOutDateTime
    mlContactInactiveReasons
    mlSOInactiveReasons
    mlInactiveReasons
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateHouselistNewSubscriptionVariables,
  APITypes.OnCreateHouselistNewSubscription
>;
export const onUpdateHouselistNew = /* GraphQL */ `subscription OnUpdateHouselistNew(
  $filter: ModelSubscriptionHouselistNewFilterInput
) {
  onUpdateHouselistNew(filter: $filter) {
    id
    accountID
    listName
    listNameId
    control
    homeValue
    homeValueBottom
    homeValueTop
    hohIncome
    hohIncomeBottom
    hohIncomeTop
    hohNetWorth
    hohNetWorthBottom
    hohNetWorthTop
    groupName
    birthDate
    deceasedDate
    distanceToSite
    doNotCall
    email
    emailBounceDate
    epm2Grade
    epm2Score
    epm2Tier
    firstName
    gender
    hasOptedOutOfEmail
    hohAge
    homePhone
    contactId
    ilContactStatus
    labelSalutation
    lastName
    letterSalutation
    neighborhood
    city
    zip5
    zipcode
    state
    address
    maritalStatus
    mlActive
    cellPhone
    primaryContact
    primarySite
    latitude
    longitude
    qasValidationStatus
    contactType
    returnedMail
    ccContactStatus
    opportunitySite
    opportunityId
    loc
    ltsGrade
    ltsScore
    primaryMotivation
    communityName
    rating
    segmentation
    settledDate
    salesStage
    priorityDate
    reservationDate
    businessType
    salesOptionDate
    apartmentName
    optOut
    optOutDateTime
    mlContactInactiveReasons
    mlSOInactiveReasons
    mlInactiveReasons
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHouselistNewSubscriptionVariables,
  APITypes.OnUpdateHouselistNewSubscription
>;
export const onDeleteHouselistNew = /* GraphQL */ `subscription OnDeleteHouselistNew(
  $filter: ModelSubscriptionHouselistNewFilterInput
) {
  onDeleteHouselistNew(filter: $filter) {
    id
    accountID
    listName
    listNameId
    control
    homeValue
    homeValueBottom
    homeValueTop
    hohIncome
    hohIncomeBottom
    hohIncomeTop
    hohNetWorth
    hohNetWorthBottom
    hohNetWorthTop
    groupName
    birthDate
    deceasedDate
    distanceToSite
    doNotCall
    email
    emailBounceDate
    epm2Grade
    epm2Score
    epm2Tier
    firstName
    gender
    hasOptedOutOfEmail
    hohAge
    homePhone
    contactId
    ilContactStatus
    labelSalutation
    lastName
    letterSalutation
    neighborhood
    city
    zip5
    zipcode
    state
    address
    maritalStatus
    mlActive
    cellPhone
    primaryContact
    primarySite
    latitude
    longitude
    qasValidationStatus
    contactType
    returnedMail
    ccContactStatus
    opportunitySite
    opportunityId
    loc
    ltsGrade
    ltsScore
    primaryMotivation
    communityName
    rating
    segmentation
    settledDate
    salesStage
    priorityDate
    reservationDate
    businessType
    salesOptionDate
    apartmentName
    optOut
    optOutDateTime
    mlContactInactiveReasons
    mlSOInactiveReasons
    mlInactiveReasons
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteHouselistNewSubscriptionVariables,
  APITypes.OnDeleteHouselistNewSubscription
>;
export const onCreateAccount = /* GraphQL */ `subscription OnCreateAccount(
  $filter: ModelSubscriptionAccountFilterInput
  $owner: String
) {
  onCreateAccount(filter: $filter, owner: $owner) {
    updateHash
    accountID
    isDeleted
    labelSaluation
    homeValueBottom
    accountNameId
    homeValueTop
    letterSaluation
    numberOfParticipants
    primaryContact
    lastModifiedDate
    otherInterestsMotivation
    createdDate
    controlFlag
    hobbiesInterest
    primarySite
    hohNetRange
    homeValueRange
    hohNetWorthTop
    hohIncomeRange
    hohIncomeBottom
    accountName
    hohIncomeTop
    hohNetWorthBottom
    parentAccountID
    returnedMail
    type
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAccountSubscriptionVariables,
  APITypes.OnCreateAccountSubscription
>;
export const onUpdateAccount = /* GraphQL */ `subscription OnUpdateAccount(
  $filter: ModelSubscriptionAccountFilterInput
  $owner: String
) {
  onUpdateAccount(filter: $filter, owner: $owner) {
    updateHash
    accountID
    isDeleted
    labelSaluation
    homeValueBottom
    accountNameId
    homeValueTop
    letterSaluation
    numberOfParticipants
    primaryContact
    lastModifiedDate
    otherInterestsMotivation
    createdDate
    controlFlag
    hobbiesInterest
    primarySite
    hohNetRange
    homeValueRange
    hohNetWorthTop
    hohIncomeRange
    hohIncomeBottom
    accountName
    hohIncomeTop
    hohNetWorthBottom
    parentAccountID
    returnedMail
    type
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAccountSubscriptionVariables,
  APITypes.OnUpdateAccountSubscription
>;
export const onDeleteAccount = /* GraphQL */ `subscription OnDeleteAccount(
  $filter: ModelSubscriptionAccountFilterInput
  $owner: String
) {
  onDeleteAccount(filter: $filter, owner: $owner) {
    updateHash
    accountID
    isDeleted
    labelSaluation
    homeValueBottom
    accountNameId
    homeValueTop
    letterSaluation
    numberOfParticipants
    primaryContact
    lastModifiedDate
    otherInterestsMotivation
    createdDate
    controlFlag
    hobbiesInterest
    primarySite
    hohNetRange
    homeValueRange
    hohNetWorthTop
    hohIncomeRange
    hohIncomeBottom
    accountName
    hohIncomeTop
    hohNetWorthBottom
    parentAccountID
    returnedMail
    type
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAccountSubscriptionVariables,
  APITypes.OnDeleteAccountSubscription
>;
export const onCreateContact = /* GraphQL */ `subscription OnCreateContact(
  $filter: ModelSubscriptionContactFilterInput
  $owner: String
) {
  onCreateContact(filter: $filter, owner: $owner) {
    doNotMail
    deceasedDate
    birthDate
    lastName
    status
    emailBounceBack
    isDeleted
    labelSaluation
    homeValueBottom
    letterSaluation
    hohNetWorth
    contactID
    hohAge
    primaryFlag
    lastModifiedDate
    mailingStreet
    mailingState
    preferredContactMethod
    epm2Score
    ilContactStatus
    emailBounceBackDate
    fullName
    primarySite
    homeValueRange
    maritalStatus
    mailingCountry
    militaryService
    hohIncomeRange
    hohIncomeBottom
    hohIncomeTop
    qasLongitude
    hasOptedOutOfEmail
    mailingCountryCode
    returnedMail
    mobilePhone
    accountID
    qasMailingValidationStatus
    email
    homeValueTop
    firstName
    mailingCity
    doNotCall
    salutation
    mlActive
    homePhone
    placeOfBirth
    masterRecordID
    emailOptOutDate
    gender
    qasLatitude
    hohNetWorthTop
    mailingZipCode
    mailingNeighborhood
    contactType
    hohNetWorthBottom
    epm2Decile
    mailingStateCode
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateContactSubscriptionVariables,
  APITypes.OnCreateContactSubscription
>;
export const onUpdateContact = /* GraphQL */ `subscription OnUpdateContact(
  $filter: ModelSubscriptionContactFilterInput
  $owner: String
) {
  onUpdateContact(filter: $filter, owner: $owner) {
    doNotMail
    deceasedDate
    birthDate
    lastName
    status
    emailBounceBack
    isDeleted
    labelSaluation
    homeValueBottom
    letterSaluation
    hohNetWorth
    contactID
    hohAge
    primaryFlag
    lastModifiedDate
    mailingStreet
    mailingState
    preferredContactMethod
    epm2Score
    ilContactStatus
    emailBounceBackDate
    fullName
    primarySite
    homeValueRange
    maritalStatus
    mailingCountry
    militaryService
    hohIncomeRange
    hohIncomeBottom
    hohIncomeTop
    qasLongitude
    hasOptedOutOfEmail
    mailingCountryCode
    returnedMail
    mobilePhone
    accountID
    qasMailingValidationStatus
    email
    homeValueTop
    firstName
    mailingCity
    doNotCall
    salutation
    mlActive
    homePhone
    placeOfBirth
    masterRecordID
    emailOptOutDate
    gender
    qasLatitude
    hohNetWorthTop
    mailingZipCode
    mailingNeighborhood
    contactType
    hohNetWorthBottom
    epm2Decile
    mailingStateCode
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateContactSubscriptionVariables,
  APITypes.OnUpdateContactSubscription
>;
export const onDeleteContact = /* GraphQL */ `subscription OnDeleteContact(
  $filter: ModelSubscriptionContactFilterInput
  $owner: String
) {
  onDeleteContact(filter: $filter, owner: $owner) {
    doNotMail
    deceasedDate
    birthDate
    lastName
    status
    emailBounceBack
    isDeleted
    labelSaluation
    homeValueBottom
    letterSaluation
    hohNetWorth
    contactID
    hohAge
    primaryFlag
    lastModifiedDate
    mailingStreet
    mailingState
    preferredContactMethod
    epm2Score
    ilContactStatus
    emailBounceBackDate
    fullName
    primarySite
    homeValueRange
    maritalStatus
    mailingCountry
    militaryService
    hohIncomeRange
    hohIncomeBottom
    hohIncomeTop
    qasLongitude
    hasOptedOutOfEmail
    mailingCountryCode
    returnedMail
    mobilePhone
    accountID
    qasMailingValidationStatus
    email
    homeValueTop
    firstName
    mailingCity
    doNotCall
    salutation
    mlActive
    homePhone
    placeOfBirth
    masterRecordID
    emailOptOutDate
    gender
    qasLatitude
    hohNetWorthTop
    mailingZipCode
    mailingNeighborhood
    contactType
    hohNetWorthBottom
    epm2Decile
    mailingStateCode
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteContactSubscriptionVariables,
  APITypes.OnDeleteContactSubscription
>;
export const onCreateSalesOption = /* GraphQL */ `subscription OnCreateSalesOption(
  $filter: ModelSubscriptionSalesOptionFilterInput
  $owner: String
) {
  onCreateSalesOption(filter: $filter, owner: $owner) {
    lossReason
    createdDate
    accountID
    apartment
    apartmentName
    rating
    community
    settledDate
    requestedMailOfBrochure
    isDeleted
    sourceID
    reservationDate
    reservedMSP
    salesOptionName
    priorityDepCommunity
    ltsScore
    ltsGrade
    lastModifiedDate
    campaignID
    priorityDate
    segmentation
    levelOfCare
    mergeFlag
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateSalesOptionSubscriptionVariables,
  APITypes.OnCreateSalesOptionSubscription
>;
export const onUpdateSalesOption = /* GraphQL */ `subscription OnUpdateSalesOption(
  $filter: ModelSubscriptionSalesOptionFilterInput
  $owner: String
) {
  onUpdateSalesOption(filter: $filter, owner: $owner) {
    lossReason
    createdDate
    accountID
    apartment
    apartmentName
    rating
    community
    settledDate
    requestedMailOfBrochure
    isDeleted
    sourceID
    reservationDate
    reservedMSP
    salesOptionName
    priorityDepCommunity
    ltsScore
    ltsGrade
    lastModifiedDate
    campaignID
    priorityDate
    segmentation
    levelOfCare
    mergeFlag
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateSalesOptionSubscriptionVariables,
  APITypes.OnUpdateSalesOptionSubscription
>;
export const onDeleteSalesOption = /* GraphQL */ `subscription OnDeleteSalesOption(
  $filter: ModelSubscriptionSalesOptionFilterInput
  $owner: String
) {
  onDeleteSalesOption(filter: $filter, owner: $owner) {
    lossReason
    createdDate
    accountID
    apartment
    apartmentName
    rating
    community
    settledDate
    requestedMailOfBrochure
    isDeleted
    sourceID
    reservationDate
    reservedMSP
    salesOptionName
    priorityDepCommunity
    ltsScore
    ltsGrade
    lastModifiedDate
    campaignID
    priorityDate
    segmentation
    levelOfCare
    mergeFlag
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteSalesOptionSubscriptionVariables,
  APITypes.OnDeleteSalesOptionSubscription
>;
export const onCreateStaffSeed = /* GraphQL */ `subscription OnCreateStaffSeed(
  $filter: ModelSubscriptionStaffSeedFilterInput
  $owner: String
) {
  onCreateStaffSeed(filter: $filter, owner: $owner) {
    id
    address
    city
    community
    createdby
    email
    firstName
    labelSalutation
    lastModifiedBy
    lastName
    letterSalutation
    loc
    owner
    postalCode
    seedDataName
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateStaffSeedSubscriptionVariables,
  APITypes.OnCreateStaffSeedSubscription
>;
export const onUpdateStaffSeed = /* GraphQL */ `subscription OnUpdateStaffSeed(
  $filter: ModelSubscriptionStaffSeedFilterInput
  $owner: String
) {
  onUpdateStaffSeed(filter: $filter, owner: $owner) {
    id
    address
    city
    community
    createdby
    email
    firstName
    labelSalutation
    lastModifiedBy
    lastName
    letterSalutation
    loc
    owner
    postalCode
    seedDataName
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateStaffSeedSubscriptionVariables,
  APITypes.OnUpdateStaffSeedSubscription
>;
export const onDeleteStaffSeed = /* GraphQL */ `subscription OnDeleteStaffSeed(
  $filter: ModelSubscriptionStaffSeedFilterInput
  $owner: String
) {
  onDeleteStaffSeed(filter: $filter, owner: $owner) {
    id
    address
    city
    community
    createdby
    email
    firstName
    labelSalutation
    lastModifiedBy
    lastName
    letterSalutation
    loc
    owner
    postalCode
    seedDataName
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteStaffSeedSubscriptionVariables,
  APITypes.OnDeleteStaffSeedSubscription
>;
export const onCreateDistanceToSite = /* GraphQL */ `subscription OnCreateDistanceToSite(
  $filter: ModelSubscriptionDistanceToSiteFilterInput
  $owner: String
) {
  onCreateDistanceToSite(filter: $filter, owner: $owner) {
    distanceToSiteId
    distance
    site
    communityId
    createdDate
    isDeleted
    lastModifiedDate
    contactId
    name
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDistanceToSiteSubscriptionVariables,
  APITypes.OnCreateDistanceToSiteSubscription
>;
export const onUpdateDistanceToSite = /* GraphQL */ `subscription OnUpdateDistanceToSite(
  $filter: ModelSubscriptionDistanceToSiteFilterInput
  $owner: String
) {
  onUpdateDistanceToSite(filter: $filter, owner: $owner) {
    distanceToSiteId
    distance
    site
    communityId
    createdDate
    isDeleted
    lastModifiedDate
    contactId
    name
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDistanceToSiteSubscriptionVariables,
  APITypes.OnUpdateDistanceToSiteSubscription
>;
export const onDeleteDistanceToSite = /* GraphQL */ `subscription OnDeleteDistanceToSite(
  $filter: ModelSubscriptionDistanceToSiteFilterInput
  $owner: String
) {
  onDeleteDistanceToSite(filter: $filter, owner: $owner) {
    distanceToSiteId
    distance
    site
    communityId
    createdDate
    isDeleted
    lastModifiedDate
    contactId
    name
    id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDistanceToSiteSubscriptionVariables,
  APITypes.OnDeleteDistanceToSiteSubscription
>;
export const onCreateFilterValue = /* GraphQL */ `subscription OnCreateFilterValue(
  $filter: ModelSubscriptionFilterValueFilterInput
) {
  onCreateFilterValue(filter: $filter) {
    listType
    fieldId
    version
    selectedValues
    relationalOperator
    description
    changeReason
    changedBy
    id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateFilterValueSubscriptionVariables,
  APITypes.OnCreateFilterValueSubscription
>;
export const onUpdateFilterValue = /* GraphQL */ `subscription OnUpdateFilterValue(
  $filter: ModelSubscriptionFilterValueFilterInput
) {
  onUpdateFilterValue(filter: $filter) {
    listType
    fieldId
    version
    selectedValues
    relationalOperator
    description
    changeReason
    changedBy
    id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateFilterValueSubscriptionVariables,
  APITypes.OnUpdateFilterValueSubscription
>;
export const onDeleteFilterValue = /* GraphQL */ `subscription OnDeleteFilterValue(
  $filter: ModelSubscriptionFilterValueFilterInput
) {
  onDeleteFilterValue(filter: $filter) {
    listType
    fieldId
    version
    selectedValues
    relationalOperator
    description
    changeReason
    changedBy
    id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteFilterValueSubscriptionVariables,
  APITypes.OnDeleteFilterValueSubscription
>;
export const onCreateFlagDefinition = /* GraphQL */ `subscription OnCreateFlagDefinition(
  $filter: ModelSubscriptionFlagDefinitionFilterInput
) {
  onCreateFlagDefinition(filter: $filter) {
    id
    listType
    fieldName
    flagValue
    friendlyName
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateFlagDefinitionSubscriptionVariables,
  APITypes.OnCreateFlagDefinitionSubscription
>;
export const onUpdateFlagDefinition = /* GraphQL */ `subscription OnUpdateFlagDefinition(
  $filter: ModelSubscriptionFlagDefinitionFilterInput
) {
  onUpdateFlagDefinition(filter: $filter) {
    id
    listType
    fieldName
    flagValue
    friendlyName
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateFlagDefinitionSubscriptionVariables,
  APITypes.OnUpdateFlagDefinitionSubscription
>;
export const onDeleteFlagDefinition = /* GraphQL */ `subscription OnDeleteFlagDefinition(
  $filter: ModelSubscriptionFlagDefinitionFilterInput
) {
  onDeleteFlagDefinition(filter: $filter) {
    id
    listType
    fieldName
    flagValue
    friendlyName
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteFlagDefinitionSubscriptionVariables,
  APITypes.OnDeleteFlagDefinitionSubscription
>;
export const onCreateDataTransferStage = /* GraphQL */ `subscription OnCreateDataTransferStage(
  $filter: ModelSubscriptionDataTransferStageFilterInput
) {
  onCreateDataTransferStage(filter: $filter) {
    id
    traceId
    fileKey
    totalInputRecords
    indexStart
    indexEnd
    addedCount
    updatedCount
    failedCount
    failureReason
    source
    expirationUnixTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDataTransferStageSubscriptionVariables,
  APITypes.OnCreateDataTransferStageSubscription
>;
export const onUpdateDataTransferStage = /* GraphQL */ `subscription OnUpdateDataTransferStage(
  $filter: ModelSubscriptionDataTransferStageFilterInput
) {
  onUpdateDataTransferStage(filter: $filter) {
    id
    traceId
    fileKey
    totalInputRecords
    indexStart
    indexEnd
    addedCount
    updatedCount
    failedCount
    failureReason
    source
    expirationUnixTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDataTransferStageSubscriptionVariables,
  APITypes.OnUpdateDataTransferStageSubscription
>;
export const onDeleteDataTransferStage = /* GraphQL */ `subscription OnDeleteDataTransferStage(
  $filter: ModelSubscriptionDataTransferStageFilterInput
) {
  onDeleteDataTransferStage(filter: $filter) {
    id
    traceId
    fileKey
    totalInputRecords
    indexStart
    indexEnd
    addedCount
    updatedCount
    failedCount
    failureReason
    source
    expirationUnixTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDataTransferStageSubscriptionVariables,
  APITypes.OnDeleteDataTransferStageSubscription
>;
export const onCreateExclusionRule = /* GraphQL */ `subscription OnCreateExclusionRule(
  $filter: ModelSubscriptionExclusionRuleFilterInput
) {
  onCreateExclusionRule(filter: $filter) {
    id
    listType
    fieldName
    excludedValues
    operator
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateExclusionRuleSubscriptionVariables,
  APITypes.OnCreateExclusionRuleSubscription
>;
export const onUpdateExclusionRule = /* GraphQL */ `subscription OnUpdateExclusionRule(
  $filter: ModelSubscriptionExclusionRuleFilterInput
) {
  onUpdateExclusionRule(filter: $filter) {
    id
    listType
    fieldName
    excludedValues
    operator
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateExclusionRuleSubscriptionVariables,
  APITypes.OnUpdateExclusionRuleSubscription
>;
export const onDeleteExclusionRule = /* GraphQL */ `subscription OnDeleteExclusionRule(
  $filter: ModelSubscriptionExclusionRuleFilterInput
) {
  onDeleteExclusionRule(filter: $filter) {
    id
    listType
    fieldName
    excludedValues
    operator
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteExclusionRuleSubscriptionVariables,
  APITypes.OnDeleteExclusionRuleSubscription
>;
